import {compose, lifecycle, withState} from 'recompose';
import Legend from './Legend';

function componentDidMount() {
  const { setHasUnavailableData, studioData } = this.props;
  setHasUnavailableData(false);
}

export default compose(
  withState('hasUnavailableData', 'setHasUnavailableData', false),
  lifecycle({ componentDidMount }),
)(Legend);



// WEBPACK FOOTER //
// src/components/googleMap/Legend/Legend.container.js